<template>
	<el-button type="primary" class="button-loading" @click="onClick" :disabled="disabled" :loading="loading">
		<template #loading>
			<div class="custom-loading">
				<svg class="circular" viewBox="-10, -10, 50, 50">
					<path
						class="path"
						d="
						M 30 15
						L 28 17
						M 25.61 25.61
						A 15 15, 0, 0, 1, 15 30
						A 15 15, 0, 1, 1, 27.99 7.5
						L 15 15" style="stroke-width: 4px; fill: rgba(0, 0, 0, 0)"
					/>
				</svg>
			</div>
		</template>
		<div v-if="!loading" class="custom-loading" style="width: 24px;">
			&nbsp;
		</div>
		{{ label ?? 'Button1' }}
	</el-button>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { ElTag } from 'element-plus';

@Options({	
	components: {
		ElTag
	},
	props: {
		label: String,
		loading: Boolean,
		disabled: Boolean
	}
})
export default class ButtonLoadingComponent extends Vue {
	/** props */
	label!: String
	loading!: Boolean;
	disabled!: Boolean;

	onClick(e: Event) {
		this.$emit('onClick', e);
	}
}
</script>

<style scoped>
.el-button.button-loading {
	padding-right: 32px;
}

	.el-button.button-loading .custom-loading .circular {
		margin-right: 6px;
		width: 18px;
		height: 18px;
		animation: loading-rotate 2s linear infinite;
	}

		.el-button.button-loading .custom-loading .circular .path {
			animation: loading-dash 1.5s ease-in-out infinite;
			stroke-dasharray: 90, 150;
			stroke-dashoffset: 0;
			stroke-width: 2;
			stroke: var(--el-button-text-color);
			stroke-linecap: round;
		}
</style>